'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HoldsIcon = require('./HoldsIcon');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HoldsIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/HoldsIcon/index.js
// module id = 1206
// module chunks = 1